module.exports = __webpack_public_path__ + "static/media/0xQuest.dc5ccc80.png";